import truncateFloat from '../helpers/truncateFloat'

describe('#truncateFloat', () => {
  it('should truncate a provided float to the provided number of decimal places and convert it to a string', () => {
    const float = 2.44444
    const decimalPlaces = 2
    const expected = '2.44'
    expect(truncateFloat({ float, n: decimalPlaces })).toEqual(expected)
  })
  it('should return an int if truncateZeroes is true', () => {
    const float = 2.000
    const n = 2
    const expected = '2'
    expect(truncateFloat({ float, n, truncateZeroes: true })).toBe(expected)
  })
})
